
import { Component, Prop, Vue} from "vue-property-decorator";
import DashboardCardScaffold from "@/components/dashboard/cards/CardScaffold.vue";
import CardItemScaffold from "@/components/dashboard/cards/CardItemScaffold.vue";
import InboxIcon from "@/components/icons/InboxIcon.vue";
import UiButton from "@/components/button/ui-button.vue";
import NewConversationButtonWithModal from "@/components/inbox/NewConversationButtonWithModal.vue";
import timeRangeForNew from "@/helpers/cardInfoHelperFunctions/timeRangeForNew";
import RouteNames from "@/entities/RouteNames";


@Component({
  components: {
    DashboardCardScaffold,
    CardItemScaffold,
    InboxIcon,
    NewConversationButtonWithModal,
    UiButton,
  },
})
export default class DashboardInbox extends Vue {
  @Prop({type: String, required: true}) readonly companyId!: string;
  @Prop({type: String, required: true}) readonly currentUserId!: string;

  routes = RouteNames;
  messages: any = null;

  get filters(): object {
    return {
      newMessages: {
        created_at: {_gt: timeRangeForNew(this.$moment)},
      }
    };
  }

  redirectToInbox(): void {
    this.$router.push({name: RouteNames.INBOX});
  }
}
